import { Link, useNavigate } from "react-router-dom";
import { Icon } from "../SVGsprite/svgsprite";
import styles from "./TypeUpload.module.scss";
import { CustomBanner } from "../Modals/CustomBanner";
import { useState } from "react";
import { useActor, useMachine } from "@xstate/react";
import { AuthState } from "../../xstate/auth.machine";
import { userCardMachine } from "../../xstate/userCard.machine";

export function TypeUpload() {
	const [stateAuth, sendAuth] = useActor(AuthState);

	if (
		stateAuth.context.type === "seller" &&
		stateAuth.context.service_order_verification_status !== "enabled"
	) {
		console.log("1");
		window.location.href = "/account";
	}

	const navigate = useNavigate();
	const [isBannerOpen, setIsBannerOpen] = useState(false);
	const [pendingNavigation, setPendingNavigation] = useState(null);
	const [stateUserCard, sendUserCard] = useMachine(userCardMachine);

	const handleCloseBanner = () => {
		setIsBannerOpen(false);
		setPendingNavigation(null);
	};

	const handleChoice = choice => {
		// Сохраняем выбор в localStorage
		// localStorage.setItem("uploadChoice", choice);
		// localStorage.setItem("uploadTimestamp", Date.now());

		// setIsBannerOpen(false);

		const isUploadBill = pendingNavigation === "/account/upload";
		const isUploadZN = pendingNavigation === "/account/order-upload";

		console.log("choice", choice, pendingNavigation);

		if (choice === "yes" && isUploadBill) {
			const formData = new FormData();
			formData.append("registration_document_type_status", "receipt");
			try {
				sendUserCard({
					type: "updateUser",
					data: formData,
				});
			} catch (e) {
				console.log(e);
			} finally {
				setIsBannerOpen(false);
				if (pendingNavigation) {
					navigate(pendingNavigation);
					setPendingNavigation(null);
				}
			}
		} else if (choice === "yes" && isUploadZN) {
			const formData = new FormData();
			formData.append("registration_document_type_status", "service_order");
			try {
				sendUserCard({
					type: "updateUser",
					data: formData,
				});
			} catch (e) {
				console.log(e);
			} finally {
				setIsBannerOpen(false);
				if (pendingNavigation) {
					navigate(pendingNavigation);
					setPendingNavigation(null);
				}
			}
		} else {
			setIsBannerOpen(false);
			if (pendingNavigation) {
				navigate(pendingNavigation);
				setPendingNavigation(null);
			}
		}

		// Если есть ожидающий переход - выполняем его
	};

	const handleLinkClick = (e, path) => {
		// Проверяем, есть ли сохраненный выбор

		if (
			stateAuth.context.registration_document_type_status === "not_selected"
		) {
			// Если выбора нет - показываем попап и предотвращаем переход
			e.preventDefault();
			setPendingNavigation(path);
			setIsBannerOpen(true);
		}
		// Если выбор есть - переход произойдет нормально (через Link)
	};

	return (
		<>
			<div className={styles.blockUpload}>
				<div className="statContainer">
					<h1>
						Зарегистрировать
						<br /> чек или заказ-наряд
					</h1>

					<div className={styles.buttons}>
						<Link
							to={`/account/upload`}
							onClick={e => handleLinkClick(e, "/account/upload")}
							className={"btn btnPrimary btnIcon newBtnUpdate"}
						>
							<Icon name="icon-add" sizeW="24" sizeH="24" />
							Загрузить чек
						</Link>
						<Link
							to={`/account/order-upload`}
							onClick={e => handleLinkClick(e, "/account/order-upload")}
							className={"btn btnPrimary btnIcon newBtnUpdate"}
						>
							<Icon name="icon-add" sizeW="24" sizeH="24" />
							Загрузить заказ-наряд
						</Link>
					</div>
				</div>
			</div>
			{isBannerOpen && (
				<CustomBanner onClose={handleCloseBanner} showCloseButton={false}>
					<div className={styles.modal_c}>
						<h2 className={styles.modal_h2}>Запомнить ваш выбор?</h2>
						<div className={styles.buttons}>
							<div
								className={"btn btnPrimary btnIcon newBtnUpdate"}
								onClick={() => handleChoice("yes")}
							>
								Да
							</div>
							<div
								className={"btn btnPrimary btnIcon newBtnUpdate"}
								onClick={() => handleChoice("no")}
							>
								Нет
							</div>
						</div>
					</div>
				</CustomBanner>
			)}
		</>
	);
}
